import React from 'react';

function ProjectCard({ project, viewMode = 'grid', onHighlight }) {
  const {
    title,
    url,
    status,
    status_label,
    uses,
    neighborhood,
    image_url,
    article_count = 0,
  } = project;

  const isSplitView = viewMode === 'split';

  const handleCardClick = (e) => {
    e.preventDefault();
    if (isSplitView && onHighlight) {
      // In split view, highlight on map instead of navigating
      onHighlight(project);
    } else {
      // In grid view (or map-only), open in new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleViewDetailsClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent card click handler from firing
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (isSplitView && onHighlight) {
        onHighlight(project);
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  };

  const usesText = Array.isArray(uses) ? uses.join(' / ') : uses;

  return (
    <article
      className="project-card"
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}
      aria-label={`View ${title}`}
    >
      {/* Image Section */}
      <div className="project-card-image-wrapper">
        <span className={`project-card-status status-${status}`}>
          {status_label}
        </span>
        {image_url ? (
          <img
            src={image_url}
            alt={title}
            className="project-card-image"
            loading="lazy"
          />
        ) : (
          <div className="project-card-no-image">
            <span>No Image</span>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="project-card-body">
        <div className="project-card-meta">
          {neighborhood && (
            <span className="project-card-neighborhood">{neighborhood}</span>
          )}
          {usesText && <span className="project-card-uses">{usesText}</span>}
        </div>
        <h3 className="project-card-title">{title}</h3>
        <div className="project-card-divider"></div>
        <div className="project-card-footer">
          <span className="project-card-article-count">
            {article_count} article{article_count !== 1 ? 's' : ''}
          </span>
          <a
            href={url}
            className="project-card-footer-link"
            onClick={handleViewDetailsClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleViewDetailsClick(e);
              }
            }}
          >
            View Details <span className="project-card-footer-arrow">→</span>
          </a>
        </div>
      </div>
    </article>
  );
}

export default ProjectCard;
